import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class VendorList {
	constructor(dom) {
		this.NAME = 'VendorList';
		this.dom = dom;
	}

	init() {
		const imgWrappers = this.dom.querySelectorAll('.vendor-list__vendor-img');

		imgWrappers.forEach(wrapper => {
			const img = wrapper.querySelector('img');
			if (!img) return;

			gsap.fromTo(img,
				{ y: '-10%' },
				{
					y: '10%',
					ease: 'none',
					scrollTrigger: {
						trigger: wrapper,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
					},
				}
			);
		});
	}
}

export default VendorList;
